import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { ResolverCacheService } from 'src/app/shared/services/resolver-cache.service';
import { UserService } from 'src/app/shared/services/user.service';
import { RegionDto } from 'src/app/shared/dtos/user.dto';

export const regionResolver: ResolveFn<RegionDto[] | null> = () => {
  const userService = inject(UserService);
  const resolverCacheService = inject(ResolverCacheService);

  return resolverCacheService.createCachedResolver<RegionDto[] | null>(
    'regions',
    () => userService.getUserRegions()
  );
};
